import styled from 'styled-components';

export const ModalContainer = styled.div`
  font-size: 14px;
`;

export const ModalTitle = styled.h2`
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 24px;
  color: rgb(0 0 0 / 88%);
`;

export const FormSection = styled.div`
  margin-bottom: 24px;
`;

export const FormLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: rgb(0 0 0 / 88%);
  margin-bottom: 8px;
`;

export const DropdownContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;

  .ant-btn {
    height: 40px;
    padding: 0 24px;
    font-weight: 500;

    &.ant-btn-primary {
      background: #1677ff;
      border-color: #1677ff;

      &:hover:not(:disabled) {
        background: #4096ff;
        border-color: #4096ff;
      }

      &:disabled {
        background: #f5f5f5;
        border-color: #d9d9d9;
        color: rgb(0 0 0 / 25%);
      }
    }
  }
`;
